import React from "react";
import { Typography } from "@mui/material";
import { StyledBlogTextContent, blogTextContentClasses } from "./StyledBlogTextContent";

interface BlogTextContentProps {
  value: string;
}

export const BlogTextContent = ({ value }: BlogTextContentProps) => {
  return (
    <StyledBlogTextContent className={blogTextContentClasses.root}>
      <Typography className={blogTextContentClasses.text}>
        {value}
      </Typography>
    </StyledBlogTextContent>
  );
};

